import Admin from './pages/Admin.jsx';
import ClientGallery from './pages/ClientGallery.jsx';
import Home from './pages/Home.jsx';
import ProofingAdmin from './pages/ProofingAdmin.jsx';

export default function App() {
  const pathname = window.location.pathname;
  if (pathname.startsWith('/admin/proofing')) return <ProofingAdmin />;
  if (pathname.startsWith('/admin')) return <Admin />;
  if (pathname.startsWith('/client/')) return <ClientGallery />;
  return <Home />;
}
